import { IReportMetricOption, IReportDimensionOption } from './report.interfaces';

export const REPORT_METRICS: IReportMetricOption[] = [
  { key: 'revenue', label: 'Revenue' },
  { key: 'cost', label: 'Cost' },
  { key: 'profit', label: 'Profit' },
  { key: 'requests', label: 'Ad Requests' },
  { key: 'adFillRate', label: 'Ad Fill Rate' },
  { key: 'impressions', label: 'Impressions' },
  { key: 'cpm', label: 'CPM' },
  { key: 'rpm', label: 'RPM' },
  { key: 'profitPercent', label: 'Profit Percent' },
  { key: 'netRevenue', label: 'Net Revenue' },
  { key: 'netCost', label: 'Net Cost' },
  { key: 'netProfit', label: 'Net Profit' },
  { key: 'completion', label: 'Completion' },
  { key: 'vcr', label: 'VCR' },
  { key: 'incomingRequests', label: 'Incoming Requests' },
  { key: 'fillRate', label: 'Fill Rate' },
  { key: 'serviceCost', label: 'Serving Cost' },
];

export const REPORT_DIMENSIONS: IReportDimensionOption[] = [
  { key: 'supplyTag', label: 'Supply Tag', group: 'supply' },
  { key: 'supplyPartner', label: 'Supply Partner', group: 'supply' },
  { key: 'supplyPartnerAlias', label: 'Supply Partner Alias', group: 'supply' },
  { key: 'demandTag', label: 'Demand Tag', group: 'demand' },
  { key: 'demandPartner', label: 'Demand Partner', group: 'demand' },
  { key: 'demandPartnerAlias', label: 'Demand Partner Alias', group: 'demand' },
  { key: 'adServer', label: 'Ad Server', group: 'common' },
  { key: 'dataPoint', label: 'Data Point', group: 'common' },
];

export const AGGREGATION_OPTIONS = [
  { key: 'sum', label: 'Sum (Total)' },
  { key: 'monthly', label: 'Month' },
  { key: 'daily', label: 'Day' },
] as const;

export const FILTER_FIELDS = [
  { key: 'supplyTag', label: 'Supply Tag' },
  { key: 'supplyPartner', label: 'Supply Partner' },
  { key: 'supplyPartnerAlias', label: 'Supply Partner Alias' },
  { key: 'demandTag', label: 'Demand Tag' },
  { key: 'demandPartner', label: 'Demand Partner' },
  { key: 'demandPartnerAlias', label: 'Demand Partner Alias' },
  { key: 'adServer', label: 'Ad Server' },
  { key: 'dataPoint', label: 'Data Point' },
];

export const CONSTRAINT_OPERATORS = ['=', '>', '>=', '<', '<='] as const;

export const DEFAULT_METRICS = ['revenue', 'cost', 'impressions', 'profit'];
export const DEFAULT_DIMENSIONS = ['supplyTag', 'demandTag'];
export const DEFAULT_AGGREGATION = 'sum';

export const DATE_RANGE_LIMITS = {
  daily: {
    maxDays: 7,
    label: '1 week',
    message: 'Daily aggregation is limited to a maximum of 7 days to ensure optimal performance.',
  },
  monthly: {
    maxDays: 183,
    label: '6 months',
    message: 'Monthly aggregation is limited to a maximum of 6 months to ensure optimal performance.',
  },
  sum: {
    maxDays: 365,
    label: '1 year',
    message: 'Sum aggregation is limited to a maximum of 1 year to ensure optimal performance.',
  },
} as const;
